<template>
    <search-list ref="sl" :pageSizes="[25,30,40]" :apiPath="apiPath" :where="where" hide-apply >
        <mm-lc title="Batch Edit">
        <template>
            <el-dropdown size="mini" trigger="click">
                <el-button size="small" type="primary">
                    <i class="el-icon-edit"></i>Change Status
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="status-active" @click.native="changeStatus('active')">Switch to Active</el-dropdown-item>
                    <el-dropdown-item class="status-paused" @click.native="changeStatus('paused')">Switch to Paused</el-dropdown-item>
                    <el-dropdown-item class="status-pending" @click.native="changeStatus('pending')">Switch to Pending</el-dropdown-item>
                    <el-dropdown-item @click.native="delRules()">Delete Record</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </template>
        </mm-lc>
		<mm-lc title="Subs Edit" v-if="ruleType==='channel'">
			<el-button size="small" type="primary" @click="editAllSubs()">
                    <i class="el-icon-edit"></i>Subs Edit
			</el-button>
		</mm-lc>
		<mm-lc title="Percentage Edit">
			<el-button size="small" type="primary" @click="editAll()">
                    <i class="el-icon-edit"></i>Percentage Edit
			</el-button>
		</mm-lc>
        <mm-lc title="Adv. Filter" v-if="ruleType==='channel'">
            <mm-adv-select no_paused v-model="where.adv_id" @change="selectRule" multiple/>
        </mm-lc>
        <mm-lc title="Channel Filter" v-if="ruleType==='adv'">
            <mm-channel-select no_paused v-model="where.channel_id" @change="selectRule" multiple/>
        </mm-lc>
        
        <mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectRules">
            <el-table-column type="selection"></el-table-column>
            <el-table-column label="Id" prop="adv_channel_id" />
            <el-table-column label="Adv name">
                <mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" :row_type="'adv'"/>
            </el-table-column>
            <el-table-column label="Channel name" prop="channel_name">
                <mm-get-detail slot-scope="sp" :row_id="sp.row.channel_id" :row_name="sp.row.channel_name" :row_type="'channel'"/>
            </el-table-column>
            <el-table-column label="Daily Cap" prop="daily_cap">
                <el-input slot-scope="sp" type="number" v-model="sp.row.daily_cap" @change="updateRule(sp.row)" />
            </el-table-column>
            <el-table-column label="Deduction Rate(%)" prop="defraud">
                <mm-input-number-percent slot-scope="sp" type="number" v-model="sp.row.defraud" :onBlur="updateRule" :row="sp.row" limit_min="-3"/>
            </el-table-column>
            <el-table-column label="Payout Rate(%)" prop="price_percent">
                <mm-input-number-percent slot-scope="sp" type="number" v-model="sp.row.price_percent" :onBlur="updateRule" :row="sp.row" />
            </el-table-column>
            <el-table-column label="Rule Status" prop="status">
                <mm-adv-channel-rule-status slot-scope="sp" v-model="sp.row.status" @change="updateRule(sp.row)" />
            </el-table-column>
            <el-table-column label="Operator" prop="operator" />
            <el-table-column label="action" width="200">
                <template slot-scope="sp">
                    <el-button type="danger" size="small" @click="del(sp.row)">DEL</el-button>
                    <el-button type="primary" plain size="small" @click="editSubs(sp.row)">Edit Subs</el-button>
                </template>
            </el-table-column>
        </mm-table>
		<el-dialog :visible.sync="showEditSubs">
			<span slot="title">Edit Subs</span>
			<mm-channel-subs v-model='currentRow.subs'></mm-channel-subs>
			<el-button type="primary" style="margin-left:150px;" @click='updateSubs()'>Save</el-button>
		</el-dialog>
		<el-dialog :visible.sync="showEditAllSubs">
			<span slot="title">Edit All Subs</span>
			<mm-channel-subs v-model="subs"></mm-channel-subs>
			<el-button type="primary" style="margin-left:150px;" @click='updateAllSubs()'>Save</el-button>
		</el-dialog>
		<el-dialog :visible.sync="showEditAll">
			<span slot="title">Edit All</span>
			<div class="edit-all-input">
				<div>Ded Rate(%)</div>
				<el-input type="number" v-model="edit_all.defraud"/>
			</div>
			<div class="edit-all-input">
				<div>Payout Rate(%)</div>
				<el-input type="number" v-model="edit_all.price_percent"/>
			</div>
			<el-button type="primary" style="margin-left:150px;" @click='updateAll()'>Save</el-button>
		</el-dialog>
    </search-list>

</template>

<script>
export default {
	data(){
		return {
			rule_arr: [],
			showEditSubs:false,
			currentRow:{},
			showEditAllSubs:false,
			showEditAll:false,
			subs:{},
			edit_all:{
				defraud: 0,
				price_percent: 0
			}
		}
	},
	props: {
		where: {
			type: Object,
			default: () => {
				return {};
			}
		},
		apiPath: {
			require: true,
			type: String
		},
		ruleType: {
			require: true,
			type: String
		}
	},
	methods: {
		async selectRule(){
			this.$refs.sl.refresh();
		},
		async updateRule(row){
			if(row.daily_cap == '' || row.daily_cap == 0 || row.status == ''){
				this.$message({
					type: 'error',
					message: 'type error',
				});
				return;
			}
			await this.$post('/advChannelRule/update',{adv_channel_id:row.adv_channel_id,
				daily_cap:row.daily_cap,
				defraud:row.defraud,
				price_percent:row.price_percent,
				status:row.status,
				subs:row.subs,
			});
			this.$refs.sl.refresh();

		},
		async updateSubs(){
			await this.updateRule(this.currentRow);
			this.showEditSubs = false;
		},
		async updateAllSubs(){
			const adv_channel_ids = [];
			for(const rule of this.rule_arr) {
				adv_channel_ids.push(rule.adv_channel_id);
			}
			await this.$post('/advChannelRule/updateAll', { subs: this.subs, rules: adv_channel_ids});
			this.showEditAllSubs = false;
			this.$refs.sl.refresh();
		},
		async updateAll(){
			const rules = [];
			for(const rule of this.rule_arr) {
				rules.push(rule.adv_channel_id);
			}
			const defraud = (this.edit_all.defraud / 100).toFixed(2);
			const price_percent = (this.edit_all.price_percent / 100).toFixed(2);
			await this.$post('/advChannelRule/updateAll', { defraud, price_percent, rules});
			this.showEditAll = false;
			this.$refs.sl.refresh();
		},
		async del(row){
			try {
				await this.$confirm('Do you want to delete this rule?', 'WARING', {
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
					type: 'warning'
				});
				await this.$post('/advChannelRule/delete',{adv_channel_id:row.adv_channel_id});
				await this.$refs.sl.refresh();
			} catch (error) {
				// this.$message({
				// 	type: 'info',
				// 	message: error
				// })
			}
			
		},
		selectRules(rule_arr){
			this.rule_arr = rule_arr;
		},
		async changeStatus(status){
			if(this.rule_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			let rules = [];
			for (const rule of this.rule_arr) {
				rules.push([rule.adv_channel_id]);
			}
			
			const result = await this.$post('/advChannelRule/updateAll',{status:status,rules:rules});
			this.$refs.sl.refresh();
		},
		async delRules(){
			if(this.rule_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Delete'
				});
				return;
			}
			try {
				await this.$confirm('Do you want to delete these rules?', 'WARING', {
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
					type: 'warning'
				});
				let rules = [];
				for (const rule of this.rule_arr) {
					rules.push([rule.adv_channel_id]);
				}
				const result = await this.$post('/advChannelRule/delAll',{rules:rules});
				this.$refs.sl.refresh();
			} catch (error) {
				this.$message({
					type: 'info',
					message: error
				})
			}
		},
		editSubs(row){
			this.currentRow = row;
			this.showEditSubs = true;
		},
		editAllSubs(){
			if(this.rule_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Edit'
				});
				return;
			}
			this.showEditAllSubs = true;
		},
		editAll(){
			if(this.rule_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Edit'
				});
				return;
			}
			this.showEditAll = true;
		}
	}
}
</script>

<style scoped>
.edit-all-input {
    display: flex;
    align-items: center;
}
.edit-all-input > div {
	width: 150px;
    margin-bottom: 20px;
}
</style>